<template>
    <div class="crumbsNavCont">
        <p class="crumbsNav">位置：<router-link to='/'>首页</router-link>>{{curPageName}}</p>
        <div class="searchBox">
            <search></search>
        </div>
    </div>
</template>

<script>
export default {
    name: "positonNav",
    props: {
        curPageName: {
            type: String,
        }
    },
};
</script>

<style lang="stylus" scoped>
.crumbsNavCont
    height 70px
    border-bottom 1px solid #D8D8D8
    margin-bottom 28px
    position relative
    .crumbsNav
        font-size 14px
        color #222
        height 100%
        line-height 70px
        a
            color #222
</style>


// WEBPACK FOOTER //
// src/components/common/positionNav.vue